(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-interval-result.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-interval-result.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  createMap,
  mapDefaults,
  sweRectangleBounds,
  worldRectangleBounds,
  locationToArray,
  getIconLeaflet,
  disableInteraction
} = svs.tur.lyckoplatsen.map;
function getIntervalResultMapHandler() {
  let map;
  let mapId;
  let intervalPins = [];
  let singleWorldRec;
  let showCenterMapButton = false;
  let maxZoom;
  let minZoom;
  let justMovedToCenter = true;
  let clusterLayers = [];
  let currentZoom;
  const eventHandlers = {};
  return {
    createMap(_ref) {
      let {
        mapOptions = {},
        evtHandlers = {}
      } = _ref;
      Object.assign(eventHandlers, evtHandlers);
      const options = _objectSpread(_objectSpread({}, mapDefaults), mapOptions);
      map = createMap(options);
      mapId = options.nodeId;
      maxZoom = options.maxZoom;
      minZoom = options.minZoom;
      this.handleZoomButtonsEvents();
      disableInteraction(map);
      map.on('resize', _.debounce(() => {
        this.uiCenterMap();
      }, 300));
      map.on('move', () => {
        if (!justMovedToCenter) {
          showCenterMapButton = true;
          this.uiCenterMap();
        }
        justMovedToCenter = false;
      });
      return map;
    },
    handleZoomButtonsEvents() {
      map.whenReady(() => {
        const mapContainer = document.getElementById(mapId);
        const zoomInButton = mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.querySelector('.leaflet-control-zoom-in');
        const zoomOutButton = mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.querySelector('.leaflet-control-zoom-out');
        if (zoomInButton) {
          zoomInButton.addEventListener('click', () => {
            const zoomLevel = map.getZoom();
            showCenterMapButton = true;
            const center = map.getCenter();
            map.setView(center, zoomLevel + 1, {
              animate: false
            });
            this.uiCenterMap();
          });
        }
        if (zoomOutButton) {
          zoomOutButton.addEventListener('click', () => {
            const zoomLevel = map.getZoom();
            showCenterMapButton = true;
            const center = map.getCenter();
            map.setView(center, zoomLevel - 1, {
              animate: false
            });
            this.uiCenterMap();
          });
        }
      });
    },
    fitBoundsSweden() {
      var _map;
      (_map = map) === null || _map === void 0 || _map.fitBounds(sweRectangleBounds, {
        minZoom,
        maxZoom
      });
    },
    findIntervalPin(_ref2) {
      let {
        productId,
        drawNumber
      } = _ref2;
      return intervalPins.find(_ref3 => {
        let {
          options
        } = _ref3;
        return options.productId === productId && options.drawNumber === drawNumber;
      });
    },
    selectIntervalPin(resultId) {
      const pin = this.findIntervalPin(resultId);
      if (pin) {
        const markerElement = pin.getElement();
        if (markerElement) {
          const svgElement = markerElement.querySelector('svg path');
          if (svgElement) {
            svgElement.setAttribute('fill', '#16FFAB'); 
          }
        }
      }
    },
    clearSelectedIntervalPin(resultId) {
      const pin = this.findIntervalPin(resultId);
      if (pin) {
        const markerElement = pin.getElement();
        if (markerElement) {
          const svgElement = markerElement.querySelector('svg path');
          if (svgElement) {
            svgElement.setAttribute('fill', '#2073E5');
          }
        }
      }
    },
    showIntervalResult() {
      let results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      let evtHandlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      Object.assign(eventHandlers, evtHandlers);
      intervalPins = results.map(_ref4 => {
        let {
          productId,
          drawNumber,
          location
        } = _ref4;
        const pinIcon = getIconLeaflet({
          color: 'blue'
        });
        const pin = leaflet.marker(locationToArray(location), {
          icon: pinIcon,
          productId,
          drawNumber
        });
        if (pin) {
          pin.off('click');
          pin.on('click', () => {
            var _eventHandlers$interv;
            return (_eventHandlers$interv = eventHandlers.intervalPinClicked) === null || _eventHandlers$interv === void 0 ? void 0 : _eventHandlers$interv.call(eventHandlers, {
              productId,
              drawNumber
            });
          });
          pin.off('keypress');
          pin.on('keypress', ev => {
            if (ev.originalEvent.key === 'Enter') {
              var _eventHandlers$interv2;
              (_eventHandlers$interv2 = eventHandlers.intervalPinClicked) === null || _eventHandlers$interv2 === void 0 || _eventHandlers$interv2.call(eventHandlers, {
                productId,
                drawNumber
              });
            }
          });
          pin.addTo(map);
        }
        return pin;
      });
      this.updateClusters();
      map.on('zoomend', () => {
        this.updateClusters();
      });
    },
    clearMapPins() {
      [...intervalPins, ...clusterLayers].forEach(layer => map.removeLayer(layer));
      clusterLayers = [];
    },
    updateClusters() {
      this.clearMapPins();
      currentZoom = map.getZoom();

      const clusters = this.createClusters(intervalPins, currentZoom);
      clusters.forEach(group => {
        if (group.length === 1) {
          group[0].addTo(map); 
        } else {
          const latlng = this.getClusterCenter(group);
          let clusterMarker;
          if (currentZoom >= 15) {
            const clusterIcon = getIconLeaflet({
              color: 'blue',
              count: group.length
            });
            clusterMarker = leaflet.marker(latlng, {
              icon: clusterIcon
            });
            clusterMarker.on('click', () => {
              let degrees = [0];
              if (group.length === 2) {
                degrees = [-30, 30];
              } else if (group.length === 3) {
                degrees = [-35, 0, 35];
              } else if (group.length === 4) {
                degrees = [-45, -15, 15, 45];
              } else if (group.length === 5) {
                degrees = [-50, -25, 0, 25, 50];
              }
              clusterMarker.remove();
              group.forEach((marker, index) => {
                marker.addTo(map);
                const markerElement = marker.getElement();
                if (markerElement) {
                  const currentTransform = getComputedStyle(markerElement).transform;
                  markerElement.style.transformOrigin = '50% 100%';
                  markerElement.style.transform = "".concat(currentTransform, " rotate(").concat(degrees[index], "deg)");
                  markerElement.style.transition = 'transform 0.3s ease';
                }
              });
            });
          } else {
            const clusterIcon = getIconLeaflet({
              color: 'blue',
              count: group.length
            });
            clusterMarker = leaflet.marker(latlng, {
              icon: clusterIcon
            });
            clusterMarker.on('click', () => {
              const nextZoom = Math.min(currentZoom + 2, 15);
              map.flyTo(latlng, nextZoom);
            });
          }
          clusterMarker.addTo(map);
          clusterLayers.push(clusterMarker);
        }
      });
    },
    createClusters(pins, zoom) {
      const clusters = [];
      const visited = new Set();
      const radius = this.getClusterRadiusByZoom(zoom >= 15 ? 15 : zoom);
      pins.forEach((pin, i) => {
        if (visited.has(i)) {
          return;
        }
        const group = [pin];
        visited.add(i);
        const posA = pin.getLatLng();
        for (let j = i + 1; j < pins.length; j++) {
          if (visited.has(j)) {
            continue;
          }
          const posB = pins[j].getLatLng();
          const distance = posA.distanceTo(posB); 

          if (distance < radius) {
            group.push(pins[j]);
            visited.add(j);
          }
        }
        clusters.push(group);
      });
      return clusters;
    },
    getClusterRadiusByZoom(zoom) {
      const zoomRadiusMap = {
        15: 5,
        14: 100,
        13: 200,
        12: 400,
        11: 800,
        10: 1500,
        9: 3000,
        8: 6000,
        7: 40000,
        6: 60000,
        5: 80000,
        4: 150000
      };
      return zoomRadiusMap[zoom] || 100000; 
    },
    getClusterCenter(pins) {
      const latSum = pins.reduce((sum, p) => sum + p.getLatLng().lat, 0);
      const lngSum = pins.reduce((sum, p) => sum + p.getLatLng().lng, 0);
      return leaflet.latLng(latSum / pins.length, lngSum / pins.length);
    },
    removeIntervalResult() {
      intervalPins.forEach(pin => {
        var _pin$remove;
        return pin === null || pin === void 0 || (_pin$remove = pin.remove) === null || _pin$remove === void 0 ? void 0 : _pin$remove.call(pin);
      });
      intervalPins = [];
    },
    centerMap() {
      this.fitBoundsSweden();
      showCenterMapButton = false;
      justMovedToCenter = true;
      this.uiCenterMap();
    },
    uiCenterMap() {
      if (showCenterMapButton) {
        eventHandlers.showCenterMapButton(true);
      } else {
        eventHandlers.showCenterMapButton(false);
      }
    },
    addWorldRectangle() {
      var _singleWorldRec;
      singleWorldRec = leaflet.rectangle(worldRectangleBounds, {
        fillColor: '#001E3C',
        fillOpacity: 0.72,
        stroke: false,
        className: 'world-rect',
        renderer: leaflet.svg({
          padding: 0.85
        })
      });
      (_singleWorldRec = singleWorldRec) === null || _singleWorldRec === void 0 || _singleWorldRec.addTo(map);
      singleWorldRec.on('click', ev => {
        leaflet.DomEvent.stopPropagation(ev);
        eventHandlers.highlightedWinGroup(null);
      });
    },
    removeMap() {
      map.remove();
      map = null;
    }
  };
}
Object.assign(svs.lyckoplatsen.components.shared_map, {
  getIntervalResultMapHandler
});

 })(window);